import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import Button from "../../../../components/PrimaryButton.js";
import breastCancerVenn from "../../../../images/breast-cancer-venn.png";
import breastCancerHistogram from "../../../../images/breast-cancer-histogram.png";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import DataTable from "./DataTable";

const useStyles = makeStyles((theme) => ({
  upperRoot: {
    flexGrow: 1,
    height: "40%",
  },
  lowerRoot: {
    flexGrow: 1,
    height: "84%",
  },
  paper: {
    height: "90%",
    position: "relative",
  },
  upperPartPEl: {
    display: "inline",
  },
  upperPartButtons: {
    position: "absolute",
    bottom: "5%",
    right: "2%",
    color: "#005691",
    fontWeight: 600,
  },
  upperPartHeader: {
    position: "absolute",
    right: 105,
    top: 30,
  },
  tab: {
    margin: "10px 0px 5px 8%",
  },
  middleLine: {
    height: 1,
    width: "95%",
    backgroundColor: "#FF7E67",
    margin: "15px auto",
  },
  buttons: {
    width: 80,
    height: 30,
    position: "absolute",
    right: 5,
    bottom: 5,
    backgroundColor: "#a8a7a5",
  },
  bottomButtons: {
    position: "absolute",
    right: "8.5%",
    bottom: 10,
  },
  bottomFirstButton: {
    marginLeft: 10,
    textDecoration: "none",
  },
  automatedPageButton: {
    position: "absolute",
    right: 140,
  },
  vennImg: {
    width: "22%",
    marginTop: 5,
    marginLeft: 100,
  },
  histogramImg: {
    width: "43%",
    marginLeft: 60,
  },
  tablePaper: {
    overflow: "auto",
    height: "80%",
    maxHeight: 180,
    paddingTop: 10,
  },
  dataTable: {
    marginTop: "1%",
    height: "50%",
    overflow: "scroll",
  },
  boxTitle: {
    borderBottom: "1px solid #FF7E67",
    padding: 7,
  },
}));

const tabStyles = makeStyles(
  {
    root: {
      minHeight: "auto",
      minWidth: "auto",
      padding: 5,
      textTransform: "capitalize",
      fontSize: "1.1rem",
    },
  },
  { name: "MuiTabs" }
);

function createData(name) {
  return { name };
}

const Features = () => {
  const [value, setValue] = useState(0);
  const [checked, setChecked] = useState([]);
  const [featureChecked, setFeatureChecked] = useState([]);

  let features = [];

  const selectedDataset = sessionStorage.getItem("dataset");

  if (selectedDataset === "Diabetes") {
    features = [
      "Pregnancies",
      "Glucose",
      "BloodPressure",
      "SkinThickness",
      "Insulin",
      "BMI",
      "DiabetesPedigreeFunction",
      "Age",
      "Outcome",
    ];
  } else {
    features = [
      "patient_id",
      "age_at_diagnosis",
      "type_of_breast_surgery",
      "cancer_type",
      "cancer_type_detailed",
      "cellularity",
      "chemotherapy",
      "pam50_+_claudin-low_subtype",
      "cohort",
      "er_status_measured_by_ihc",
      "er_status,neoplasm_histologic_grade",
      "her2_status_measured_by_snp6",
      "her2_status",
      "tumor_other_histologic_subtype",
      "hormone_therapy",
      "inferred_menopausal_state",
      "integrative_cluster",
      "primary_tumor_laterality",
      "lymph_nodes_examined_positive",
      "mutation_count",
      "nottingham_prognostic_index",
      "oncotree_code",
      "overall_survival_months",
      "overall_survival",
      "pr_status,radio_therapy",
      "3-gene_classifier_subtype",
      "tumor_size",
      "tumor_stage",
    ];
  }

  const rows = features.map((item) => createData(item));

  const tabClass = tabStyles();
  const classes = useStyles();

  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleFeatureToggle = (value) => () => {
    const currentIndex = featureChecked.indexOf(value);
    const newChecked = [...featureChecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setFeatureChecked(newChecked);
  };

  const modelCheckList = [
    "Normalize",
    "Clean",
    "Check for NaN",
    "Find Outliers",
    "Discretize",
  ].map((value) => {
    return (
      <ListItem
        style={{ height: 35 }}
        key={value}
        role={undefined}
        dense
        button
        onClick={handleToggle(value)}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={checked.indexOf(value) !== -1}
            tabIndex={-1}
            disableRipple
            inputProps={{ "aria-labelledby": value }}
          />
        </ListItemIcon>
        <ListItemText id={value} primary={`${value}`} />
      </ListItem>
    );
  });

  const featureCheckList = features.map((value) => {
    return (
      <ListItem
        style={{ height: 35 }}
        key={value}
        role={undefined}
        dense
        button
        onClick={handleFeatureToggle(value)}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={featureChecked.indexOf(value) !== -1}
            tabIndex={-1}
            disableRipple
            inputProps={{ "aria-labelledby": value }}
          />
        </ListItemIcon>
        <ListItemText id={value} primary={`${value}`} />
      </ListItem>
    );
  });

  return (
    <>
      <Tabs
        className={classes.tab}
        indicatorColor="secondary"
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
      >
        <Tab className={tabClass.root} label="Manual" />
        <Tab className={tabClass.root} label="Automated" />
      </Tabs>
      {/* Manual Page */}
      {value === 0 && (
        <>
          <Grid
            className={classes.upperRoot}
            container
            justify="center"
            spacing={5}
          >
            <Grid item xs={10}>
              <h3 className={classes.upperPartHeader}>Data Analysis</h3>

              <div className={classes.paper}>
                {selectedDataset === "Diabetes" ? (
                  <div className={classes.dataTable}>
                    <DataTable />
                  </div>
                ) : (
                  <div>
                    <img
                      className={classes.vennImg}
                      src={breastCancerVenn}
                      alt="breast-cancer-venn"
                    />
                    <img
                      className={classes.histogramImg}
                      src={breastCancerHistogram}
                      alt="breast-cancer-histogram"
                    />
                  </div>
                )}
                <div className={classes.upperPartButtons}></div>
              </div>
            </Grid>
          </Grid>

          <div className={classes.middleLine}></div>
          {/* FEATURES */}
          <Grid
            className={classes.upperRoot}
            container
            justify="center"
            spacing={5}
          >
            <Grid item xs={5}>
              <Paper elevation={20} className={classes.paper}>
                <div className={classes.boxTitle}>
                  <h3>Features</h3>
                </div>
                <div className={classes.tablePaper}>{featureCheckList}</div>
                <Button
                  styleClasses={classes.buttons}
                  innerText="Remove"
                ></Button>
              </Paper>
            </Grid>
            <Grid item xs={5}>
              <Paper elevation={20} className={classes.paper}>
                <div className={classes.boxTitle}>
                  <h3>Preprocess</h3>
                </div>
                <div className={classes.tablePaper}>{modelCheckList}</div>
                <Button
                  styleClasses={classes.buttons}
                  innerText="Execute"
                ></Button>
              </Paper>
            </Grid>
          </Grid>
          <div className={classes.bottomButtons}>
            <Button innerText="Reset"></Button>
            <Link
              className={classes.bottomFirstButton}
              to="/methods/new-method/model"
            >
              <Button innerText="Next"></Button>
            </Link>
          </div>
        </>
      )}
      {value === 1 && (
        <>
          <Grid
            className={classes.lowerRoot}
            container
            justify="center"
            spacing={10}
          >
            <Grid item xs={5}>
              <h3>Features</h3>
              <Paper elevation={20} className={classes.paper}>
                <div>
                  <Button
                    styleClasses={classes.buttons}
                    innerText="Remove"
                  ></Button>
                  <Button
                    styleClasses={`${classes.buttons} ${classes.automatedPageButton}`}
                    innerText="Autoprocess"
                  ></Button>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={5}>
              <h3>Extract</h3>
              <Paper elevation={20} className={classes.paper}>
                <Button
                  styleClasses={classes.buttons}
                  innerText="Execute"
                ></Button>
              </Paper>
            </Grid>
            <div className={classes.bottomButtons}>
              <Button innerText="Next"></Button>
            </div>
          </Grid>
        </>
      )}
    </>
  );
};

export default Features;
